<template>
  <div class="sidebar-left">
    <div class="sidebar">
      <!-- Logged In User Profile Sidebar -->
      <user-profile-sidebar
        :shall-show-user-profile-sidebar="shallShowUserProfileSidebar"
        :profile-user-data="profileUserData"
        @close-sidebar="$emit('update:shall-show-user-profile-sidebar', false)"
      />

      <!-- Sidebar Content -->
      <div class="sidebar-content" :class="{ show: mqShallShowLeftSidebar }">
        <!-- Sidebar close icon -->
        <span class="sidebar-close-icon">
          <feather-icon
            icon="XIcon"
            size="16"
            @click="$emit('update:mq-shall-show-left-sidebar', false)"
          />
        </span>

        <!-- Header -->
        <div class="chat-fixed-search">
          <div class="d-flex align-items-center w-100">
            <!-- Search -->
            <b-input-group class="input-group-merge ml-1 w-100 round">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" class="text-muted" />
              </b-input-group-prepend>
              <b-form-input
                v-model="searchQuery"
                :placeholder="$t('pages.chat.search')"
              />
            </b-input-group>
          </div>
        </div>

        <!-- ScrollArea: Chat & Contacts -->
        <vue-perfect-scrollbar
          :settings="perfectScrollbarSettings"
          class="chat-user-list-wrapper list-group scroll-area"
          @ps-scroll-y="handleScroll"
        >
          <!-- Contacts Title -->
          <h4 class="chat-list-title">
            {{ $t("pages.chat.conversations") }}
            <span
              v-if="isRefreshingContacts"
              class="auto-refresh-indicator"
              :title="$t('pages.chat.refreshingContacts')"
            >
              <i class="fas fa-sync-alt fa-spin"></i>
            </span>
          </h4>
          
          <!-- Initial loading state -->
          <div v-if="loadingContacts && filteredContacts.length === 0" class="initial-loading">
            <div class="loading-spinner">
              <div class="spinner"></div>
              <span class="loading-text">{{ $t("pages.chat.loadingConversations") }}</span>
            </div>
          </div>
          
          <!-- No conversations message -->
          <h5 v-if="!loadingContacts && !filteredContacts.length" class="chat-list-title text-dark">
            {{ $t("pages.chat.noConversations") }}
          </h5>
          <ul class="chat-users-list contact-list media-list">
            <chat-contact
              v-for="contact in filteredContacts"
              :key="contact.idConversation"
              :user="contact"
              :is-active="contact.idConversation == activeChatContactId"
              tag="li"
              @click="openChat(contact.fullName, contact.idConversation, contact.avatar)"
            />
          </ul>
          
          <!-- Loading indicator for pagination -->
          <div v-if="loadingContacts && !allContactsLoaded && filteredContacts.length > 0" class="loading-indicator">
            <div class="loading-spinner">
              <div class="spinner small"></div>
              <span class="loading-text">{{ $t("pages.chat.loadingMore") }}</span>
            </div>
          </div>
          
          <!-- End of conversations indicator -->
          <div v-if="allContactsLoaded && filteredContacts.length > 0" class="end-indicator">
            <span class="end-text">{{ $t("pages.chat.noMoreConversations") }}</span>
          </div>
        </vue-perfect-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import { BAvatar, BInputGroup, BInputGroupPrepend, BFormInput } from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { ref, computed } from "@vue/composition-api";
import ChatContact from "./ChatContact.vue";
import UserProfileSidebar from "./UserProfileSidebar.vue";
import _ from "lodash";

export default {
  components: {
    // BSV
    BAvatar,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,

    // 3rd party
    VuePerfectScrollbar,

    // SFC
    ChatContact,
    UserProfileSidebar,
  },
  data: () => ({
    searchQuery: null,
  }),
  watch: {
    searchQuery: _.debounce(function (newValue) {
      this.$emit("filter-contacts", newValue);
    }, 500), // Espera 500ms después de que el usuario deje de escribir
  },
  props: {
    currentPageContact: {
      type: Number,
      required: true,
    },
    totalPagesContact: {
      type: Number,
      required: true,
    },
    contacts: {
      type: Array,
      required: true,
    },
    shallShowUserProfileSidebar: {
      type: Boolean,
      required: true,
    },
    profileUserData: {
      type: Object,
      required: true,
    },
    profileUserMinimalData: {
      type: Object,
      required: true,
    },
    activeChatContactId: {
      type: String,
      default: null,
    },
    mqShallShowLeftSidebar: {
      type: Boolean,
      required: true,
    },
    loadingContacts: {
      type: Boolean,
      default: false,
    },
    allContactsLoaded: {
      type: Boolean,
      default: false,
    },
    isRefreshingContacts: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    };

    const resolveChatContact = (idConversation) =>
      props.contacts.find((contact) => contact.idConversation === idConversation);

    const filteredContacts = computed(() => props.contacts);

    return {
      // filteredChatsContacts,
      filteredContacts,

      // UI
      resolveChatContact,
      perfectScrollbarSettings,
    };
  },

  methods: {
    handleScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      
      // Detectar si el usuario está cerca del final del scroll (con un margen de 50px)
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        // Evitar múltiples solicitudes simultáneas
        if (this.loadingContacts || this.allContactsLoaded) return;
        
        // Verificar si hay más páginas disponibles
        if (this.currentPageContact >= this.totalPagesContact) return;
        
        const nextPage = this.currentPageContact + 1;
        console.log('Loading more contacts, page:', nextPage);
        this.$emit("load-more-contacts", nextPage);
      }
    },
    openChat(fullName, idConversation, avatar) {
      console.log('conversationID->',idConversation)
      console.log('Active chat id->',this.activeChatContactId);
      // localStorage.setItem("activeChatContactId", idConversation);
      this.$emit("open-chat", fullName, idConversation, avatar);
    },

  },
};
</script>

<style scoped>
.loading-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  margin: 10px 0;
}

.initial-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  margin: 20px 0;
}

.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.spinner {
  width: 24px;
  height: 24px;
  border: 2px solid #e3e3e3;
  border-top: 2px solid #7367f0;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.spinner.small {
  width: 16px;
  height: 16px;
  border-width: 1.5px;
}

.loading-text {
  font-size: 12px;
  color: #6e6b7b;
  font-weight: 500;
}

.end-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  margin: 10px 0;
}

.end-text {
  font-size: 12px;
  color: #b9b9c3;
  font-style: italic;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .loading-indicator {
    padding: 15px;
  }
  
  .loading-text {
    font-size: 11px;
  }
  
  .end-text {
    font-size: 11px;
  }
}

/* Auto-refresh indicator */
.auto-refresh-indicator {
  margin-left: 8px;
  font-size: 12px;
  color: #7367f0;
  opacity: 0.8;
}

.auto-refresh-indicator i {
  font-size: 10px;
}

.chat-list-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
